var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8125 3.75C8.26086 3.75 8.65893 4.03691 8.80071 4.46226L10.3287 9.04628L14.9127 10.5743C15.3381 10.7161 15.625 11.1141 15.625 11.5625C15.625 12.0109 15.3381 12.4089 14.9127 12.5507L10.3287 14.0787L8.80071 18.6627C8.65893 19.0881 8.26086 19.375 7.8125 19.375C7.36414 19.375 6.96607 19.0881 6.82429 18.6627L5.29628 14.0787L0.712263 12.5507C0.286906 12.4089 0 12.0109 0 11.5625C0 11.1141 0.286906 10.7161 0.712263 10.5743L5.29628 9.04628L6.82429 4.46226C6.96607 4.03691 7.36414 3.75 7.8125 3.75Z",
    fill: "url(#paint0_linear_0_71)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1458 0C16.4149 0 16.6537 0.172144 16.7388 0.427358L17.5514 2.86527L19.9893 3.67791C20.2445 3.76298 20.4167 4.00181 20.4167 4.27083C20.4167 4.53985 20.2445 4.77869 19.9893 4.86376L17.5514 5.6764L16.7388 8.11431C16.6537 8.36952 16.4149 8.54167 16.1458 8.54167C15.8768 8.54167 15.638 8.36952 15.5529 8.11431L14.7403 5.6764L12.3024 4.86376C12.0471 4.77869 11.875 4.53985 11.875 4.27083C11.875 4.00181 12.0471 3.76298 12.3024 3.67791L14.7403 2.86527L15.5529 0.427358C15.638 0.172144 15.8768 0 16.1458 0Z",
    fill: "url(#paint1_linear_0_71)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_71",
    x1: 10.2083,
    y1: 0,
    x2: 10.2083,
    y2: 19.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC2130"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_71",
    x1: 10.2083,
    y1: 0,
    x2: 10.2083,
    y2: 19.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC2130"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.06148796fcc61258b1be67b58286791e.svg";
export { ForwardRef as ReactComponent };